// extracted by mini-css-extract-plugin
module.exports = {"pinnedSquare":"pinnedIndicator_pinnedSquare__jXEbo"};